module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowledgePage",
    attrs: {
      "id": "ack01"
    }
  }, [_c('a', {
    attrs: {
      "id": "pageviii"
    }
  }), _c('a', {
    attrs: {
      "id": "pageix"
    }
  }, [_c('h2', {
    staticClass: "acknowledgeHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgeText"
  }, [_vm._v("For Nate…")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgeText"
  }, [_vm._v("Thank you for the perfect wedding—peaceful, joyous, and loving."), _c('br'), _vm._v(" I love you more every day.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e2999e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781439164341_ack01.vue
// module id = 75
// module chunks = 0